import type { To } from 'react-router-dom';

const EXTERNAL_HREF_PATTERN = /^[a-zA-Z][a-zA-Z\d+\-.]*:/;
const HASH_SEPARATOR = '#';
const QUERY_SEPARATOR = '?';

export const TEAMS_QUERY_KEY = 'teams';
const TEAMS_VALUE_PATTERN = /^[A-Za-z0-9_,.-]+$/;

export function extractTeamsParam(
  searchParams: URLSearchParams
): string | null {
  const raw = searchParams.get(TEAMS_QUERY_KEY);
  return raw && TEAMS_VALUE_PATTERN.test(raw) ? raw : null;
}

export function appendTeamsToHref(
  href: string,
  teamsParam: string | null,
  { skipExternal = true }: { skipExternal?: boolean } = {}
): string {
  if (!teamsParam) return href;
  if (skipExternal && EXTERNAL_HREF_PATTERN.test(href)) return href;

  const [withoutHash, hashFragment] = href.split(HASH_SEPARATOR);
  const [path, existingQuery] = withoutHash.split(QUERY_SEPARATOR);
  const params = new URLSearchParams(existingQuery || '');
  if (params.has(TEAMS_QUERY_KEY)) {
    return href;
  }
  params.set(TEAMS_QUERY_KEY, teamsParam);
  const hash = hashFragment ? `${HASH_SEPARATOR}${hashFragment}` : '';
  const query = params.toString();
  return `${path}${query ? `${QUERY_SEPARATOR}${query}` : ''}${hash}`;
}

export function appendTeamsToTo(to: To, teamsParam: string | null): To {
  if (!teamsParam) return to;
  if (typeof to === 'string') {
    return appendTeamsToHref(to, teamsParam);
  }
  const params = new URLSearchParams((to.search ?? '').replace(/^\?/, ''));
  if (params.has(TEAMS_QUERY_KEY)) {
    return to;
  }
  params.set(TEAMS_QUERY_KEY, teamsParam);
  const search = params.toString();
  return { ...to, search: search ? `${QUERY_SEPARATOR}${search}` : '' };
}
